import React, { Component } from 'react';
import { BarChart, Bar, XAxis, YAxis, LabelList, ResponsiveContainer } from 'recharts';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class SiteCntBarChart extends Component {

    handleSelectedSiteName = (siteName) => {
        const { opbSiteCnt } = this.props;
        opbSiteCnt.forEach(site => {
            if (site.siteName === siteName) this.props.handleSelectedSiteID(site.siteID);
        });
    };

    render() {
        const { opbSiteCnt, maxCnt } = this.props;

        return (
            <ResponsiveContainer width="100%" height={230}>
                <BarChart
                    margin={{ top: 10 }}
                    data={opbSiteCnt}
                >
                    <XAxis dataKey="siteName" type="category" interval={0} tick={<CustomizedTick handleSelectedSiteName={this.handleSelectedSiteName} />} />
                    <YAxis type="number" hide domain={[0, maxCnt]} />
                    <Bar type="number" dataKey="totalCnt" fill="#2ac190" minPointSize={3} barSize={7}>
                        <LabelList dataKey="totalCnt" content={<CustomizedLabel />} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        );
    }
}


class CustomizedTick extends Component {

    handleSelectedSiteName = () => {
        this.props.handleSelectedSiteName(this.props.payload.value);
    };

    render() {
        const { x, y, payload } = this.props;

        return (
            <>
                <OverlayTrigger overlay={<Tooltip>{payload.value}</Tooltip>}>
                    <text className=""
                        x={x}
                        y={y + 10}
                        textAnchor="middle"
                        style={{ fontSize: 10, cursor: "pointer" }}
                        onClick={this.handleSelectedSiteName}
                    >
                        {payload.value.slice(0, 3)}
                    </text>
                </OverlayTrigger>
            </>
        );
    }
}

class CustomizedLabel extends Component {

    render() {
        const { x, y, width, value, color } = this.props;
        const fontSize = 10;

        return (
            <>
                <text className=""
                    x={x + width / 2}
                    y={y - 5}
                    fill={color}
                    textAnchor="middle"
                    style={{ fontSize: fontSize }}
                >
                    {value}
                </text>
            </>
        );
    }
}

export default SiteCntBarChart;
